import { useEffect } from 'react';
import { Modal } from 'semantic-ui-react';
import './LoginModal.scss';
import { useNavigate } from 'react-router';
import api from '../../../../utils/api';
import { setToken } from '../../../../utils/authHelper';

interface LoginModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onLogin: () => void;
}

function LoginModal({open, setOpen, onLogin}:LoginModalProps) {
  const navigate = useNavigate()
  useEffect(()=>{
    if(open){
    if ('VKIDSDK' in window) {
        const VKID = window.VKIDSDK as any;

        VKID.Config.init({
            app: 53542544,
            redirectUrl: 'https://story-maker.pro/vk-login',
            responseMode: VKID.ConfigResponseMode.Callback,
            source: VKID.ConfigSource.LOWCODE,
            scope: '', // Заполните нужными доступами по необходимости
        });

        const oneTap = new VKID.OneTap();

        oneTap.render({
            container: document.getElementById('vk-login'),
            showAlternativeLogin: true,
            oauthList: [
            'ok_ru',
            'mail_ru'
            ]
        })
        .on(VKID.WidgetEvents.ERROR, vkidOnError)
        .on(VKID.OneTapInternalEvents.LOGIN_SUCCESS, function (payload) {
            const code = payload.code;
            const deviceId = payload.device_id;

            VKID.Auth.exchangeCode(code, deviceId)
            .then(vkidOnSuccess)
            .catch(vkidOnError);
        });
    
        function vkidOnSuccess(data) {
            api.vkAuthorize(data).then(response => {
                setToken(response.token);
                navigate('/');
            })
        }
    
        function vkidOnError(error) {
            // Обработка ошибки
        }
        }   
    }
/////////////////// ======================================
    // if ('VKIDSDK' in window) {
    //   const VKID = window.VKIDSDK as any;

    //   VKID.Config.init({
    //     app: 53542544,
    //     redirectUrl: 'https://story-maker.pro/vk-login',
    //     responseMode: VKID.ConfigResponseMode.Callback,
    //     source: VKID.ConfigSource.LOWCODE,
    //     scope: '', // Заполните нужными доступами по необходимости
    //   });

    //   const floatingOneTap = new VKID.FloatingOneTap();

    //   floatingOneTap.render({
    //     appName: 'Story maker',
    //     oauthList: [
    //       'ok_ru',
    //       'mail_ru'
    //     ],
    //     showAlternativeLogin: true
    //   })
    //   .on(VKID.WidgetEvents.ERROR, vkidOnError)
    //   .on(VKID.FloatingOneTapInternalEvents.LOGIN_SUCCESS, function (payload) {
    //     const code = payload.code;
    //     const deviceId = payload.device_id;

    //     VKID.Auth.exchangeCode(code, deviceId)
    //       .then(vkidOnSuccess)
    //       .catch(vkidOnError);
    //   });
    
    //   function vkidOnSuccess(data) {
    //     floatingOneTap.close();
        
    //     // Обработка полученного результата
    //   }
    
    //   function vkidOnError(error) {
    //     // Обработка ошибки
    //   }
    // }


/////////////=======================

    // if ('VKIDSDK' in window) {
    //   const VKID = window.VKIDSDK as any;

    //   VKID.Config.init({
    //     app: 53542544,
    //     redirectUrl: 'https://story-maker.pro/vk-login',
    //     responseMode: VKID.ConfigResponseMode.Callback,
    //     source: VKID.ConfigSource.LOWCODE,
    //     scope: '', // Заполните нужными доступами по необходимости
    //   });

    //   const oAuth = new VKID.OAuthList();

    //   oAuth.render({
    //     container: document.getElementById('vk-login'),
    //     oauthList: [
    //       'vkid',
    //       'ok_ru',
    //       'mail_ru'
    //     ]
    //   })
    //   .on(VKID.WidgetEvents.ERROR, vkidOnError)
    //   .on(VKID.OAuthListInternalEvents.LOGIN_SUCCESS, function (payload) {
    //     const code = payload.code;
    //     const deviceId = payload.device_id;

    //     VKID.Auth.exchangeCode(code, deviceId)
    //       .then(vkidOnSuccess)
    //       .catch(vkidOnError);
    //   });
    
    //   function vkidOnSuccess(data) {
    //     // Обработка полученного результата
    //   }
    
    //   function vkidOnError(error) {
    //     // Обработка ошибки
    //   }
    // }

  }, [open])
    return <Modal
        open={open}
        onClose={() => setOpen(false)}
        className='login-modal'
        centered={false}
        closeIcon
        size='small'
    >
        <Modal.Header>Войти или зарегистрироваться</Modal.Header>
        <Modal.Content>
            <div id="vk-login"></div>
        </Modal.Content>
    </Modal>
};

export default LoginModal;